export default {
  MAX_DONUTS: 8
};
